<template>
  <div>
    <button
      :disabled="isDownloading"
      class="flex items-center gap-[4px] p-[6px] font-normal text-[#08A0F7] underline hover:text-[#333333] hover:undeline transition duration-300 px-[10px] py-[6px]"
      @click="emitRequestDownload"
    >
      <b-spinner
        v-if="isDownloading"
        variant="primary"
        small
      />
      Download
    </button>
  </div>
</template>

<script>
/**
 * @description - Component unduh invoice kompack untuk mengurangi kompleksitas pada component Tagihan
 * @property {Number} noInvoice - Nomor invoice yang akan diunduh
 * @property {Function} requestDownload - Fungsi untuk mengunduh invoice
 * @example
 * <DownloadInvoice
 *   :no-invoice="1"
 *   @request-download="generatePdf"
 * />
 */

export default {
  name: 'DownloadInvoice',
  props: {
    noInvoice: {
      type: Number,
      required: true,
    },
    partnerName: {
      type: String,
      required: true,
    },
    period: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    addToQueue: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isInvoiceReady: false,
      pdfData: null,
      isDownloading: false,
    }
  },
  methods: {
    onCompleteCallback() {
      this.isDownloading = false
    },
    fetchDetail() {
      this.isLoading = true
      this.$http_new.get(`/kompack/api/v1/stock-recaps/low-moving-stock/${this.noInvoice}`).then(res => {
        this.addToQueue({
          task: async () => {
            const generateKompackInvoice = (await import('../utils/generateKompackInvoice')).default
            await generateKompackInvoice({
              table: res.data.data,
              partnerName: this.partnerName,
              period: this.period,
              status: this.status,
            })
          },
          onComplete: () => {
            this.isDownloading = false
          },
        })
      }).catch(err => {
        this.isError = true
        this.$toast_error({ message: 'Gagal mengambil detail tagihan, silahkan coba lagi.' })
      }).finally(() => {
        this.isLoading = false
      })
    },
    emitRequestDownload() {
      this.isDownloading = true
      this.fetchDetail(this.noInvoice)
    },
  },
}
</script>
